import { render, staticRenderFns } from "./Detalhes_Usuario.vue?vue&type=template&id=0f18a0a6&"
import script from "./Detalhes_Usuario.vue?vue&type=script&lang=js&"
export * from "./Detalhes_Usuario.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes_Usuario.vue?vue&type=style&index=0&id=0f18a0a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports